import { Carousel, Col, Row } from "antd";
import React, { useRef } from "react";
import { IoMdArrowBack, IoMdArrowForward } from "react-icons/io";
import { Link } from "react-router-dom";
import styles from "../LandingV2.module.scss";

import support_education from "../images/support_education.webp";
import support_education_btn from "../images/support_education_btn.svg";
import support_food from "../images/support_food.webp";
import support_food_btn from "../images/support_food_btn.svg";
import support_healthcare from "../images/support_healthcare.webp";
import support_healthcare_btn from "../images/support_healthcare_btn.svg";
import support_water from "../images/support_water.webp";
import support_water_btn from "../images/support_water_btn.svg";

export const LifeChangeSlider = () => {
  const changeLiveRef = useRef(null);
  return (
    <section className={styles.change_lives + " container"}>
      <h2 className="text-center text-sm-start fs-2">
        Make a Difference with Every Purchase
      </h2>

      <button
        className={"mb_only"}
        style={{ left: "1.5rem" }}
        onClick={() => changeLiveRef.current.prev()}
      >
        <IoMdArrowBack size={30} />
      </button>
      <button
        className={"mb_only"}
        style={{ right: "1.5rem" }}
        onClick={() => changeLiveRef.current.next()}
      >
        <IoMdArrowForward size={30} />
      </button>

      <Row>
        <Col span={24}>
          <Carousel
            dots={false}
            ref={changeLiveRef}
            draggable={true}
            autoplay
            slidesToShow={2}
            slidesToScroll={1}
            responsive={[
              {
                breakpoint: 1000,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 3,
                },
              },
              {
                breakpoint: 600,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2,
                },
              },
              {
                breakpoint: 480,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                },
              },
            ]}
          >
            <div className="pe-0 ps-0 ps-sm-0 pe-sm-4 position-relative">
              <img
                src={support_education}
                alt="banner"
                className="img-fluid"
                loading="lazy"
              />
              <Link
                to={"/desi-hands"}
                className={`position-absolute start-50 translate-middle ${styles.support_button}`}
              >
                <div className="d-flex align-items-center gap-2">
                  <img
                    src={support_education_btn}
                    alt="support_education_btn"
                    height={25}
                    className="w-auto"
                  />
                  <span>Support Education</span>
                </div>
              </Link>
            </div>
            <div className="pe-0 ps-0 ps-sm-0 pe-sm-4 position-relative">
              <img
                src={support_water}
                alt="banner"
                className="img-fluid"
                loading="lazy"
              />
              <Link
                to={"/desi-hands"}
                className={`position-absolute start-50 translate-middle ${styles.support_button}`}
              >
                <div className="d-flex align-items-center gap-2">
                  <img
                    src={support_water_btn}
                    alt="support_education_btn"
                    height={25}
                    className="w-auto"
                  />
                  <span>Support Clean Drinking Water</span>
                </div>
              </Link>
            </div>
            <div className="pe-0 ps-0 ps-sm-0 pe-sm-4 position-relative">
              <img
                src={support_food}
                alt="banner"
                className="img-fluid"
                loading="lazy"
              />
              <Link
                to={"/desi-hands"}
                className={`position-absolute start-50 translate-middle ${styles.support_button}`}
              >
                <div className="d-flex align-items-center gap-2">
                  <img
                    src={support_food_btn}
                    alt="support_education_btn"
                    height={25}
                    className="w-auto"
                  />
                  <span>Support Food and Nutrition</span>
                </div>
              </Link>
            </div>
            <div className="pe-0 ps-0 ps-sm-0 pe-sm-4 position-relative">
              <img
                src={support_healthcare}
                alt="banner"
                className="img-fluid"
                loading="lazy"
              />
              <Link
                to={"/desi-hands"}
                className={`position-absolute start-50 translate-middle ${styles.support_button}`}
              >
                <div className="d-flex align-items-center gap-2">
                  <img
                    src={support_healthcare_btn}
                    alt="support_education_btn"
                    height={25}
                    className="w-auto"
                  />
                  <span>Support Healthcare</span>
                </div>
              </Link>
            </div>
          </Carousel>
        </Col>
      </Row>
    </section>
  );
};
